import { locateID } from "@xbs/lib-dom";
import { isDefined, isSameId, treeToFlatten } from "../helpers";
export function selection(node, config) {
    let pressedElem;
    const api = config.api;
    const readonly = config.readonly;
    const handleDown = (event) => {
        pressedElem = event.target;
    };
    const handleUp = (event) => {
        const id = locateID(pressedElem, "data-list-id");
        const element = pressedElem === event.target;
        const { stateEditableItem } = api.getState();
        if (isSameId(stateEditableItem?.id, id)) {
            return;
        }
        if (element) {
            const menuId = locateID(pressedElem, "data-menu-id");
            const isContextMenu = event.button === 2;
            const selected = api.getSelection();
            let ctrlMode = event.ctrlKey || event.metaKey;
            let shiftMode = event.shiftKey;
            if (readonly) {
                ctrlMode = shiftMode = false;
            }
            if ((isContextMenu && selected.some(i => isSameId(i, id))) ||
                (menuId && selected.some(i => isSameId(i, menuId)))) {
                return;
            }
            handleSelectAction({
                id,
                api,
                ctrlMode,
                shiftMode,
            });
            event.stopPropagation();
            document.getSelection().removeAllRanges();
        }
    };
    node.addEventListener("mousedown", handleDown);
    node.addEventListener("mouseup", handleUp);
    return {
        destroy() {
            node.removeEventListener("mousedown", handleDown);
            node.removeEventListener("mouseup", handleUp);
        },
    };
}
function handleSelectAction({ id, api, ctrlMode, shiftMode, }) {
    const { selected, treeTasks, taskShape } = api.getState();
    if (!isDefined(id)) {
        api.eachSelected(id => {
            api.exec("unselect-task", { id });
        });
        return;
    }
    const task = api.getTask({ id });
    if (ctrlMode && task?.selected) {
        api.exec("unselect-task", { id });
        const parents = api.getParentIds({ id });
        for (const parentId of parents) {
            const parent = api.getTask({ id: parentId });
            if (parent?.selected) {
                api.exec("unselect-task", { id: parentId });
            }
        }
        return;
    }
    if (task?.selected) {
        if (!(ctrlMode || shiftMode)) {
            api.eachSelected(i => {
                if (!isSameId(i, id))
                    api.exec("unselect-task", { id: i });
            });
        }
        return;
    }
    api.exec("select-task", {
        id,
        join: ctrlMode || shiftMode,
    });
    if (ctrlMode || shiftMode) {
        setChildrenSelection(api, id);
    }
    if (!ctrlMode && shiftMode && selected.length > 1) {
        const hideCompleted = taskShape?.completed?.taskHide;
        const filtredTask = hideCompleted
            ? treeToFlatten(treeTasks).filter(t => !t.checked)
            : treeToFlatten(treeTasks);
        const firstSelection = selected[0];
        const firstIndex = filtredTask.findIndex(task => isSameId(task.id, firstSelection));
        const targetIndex = filtredTask.findIndex(task => isSameId(task.id, id));
        if (firstIndex < 0 || targetIndex < 0)
            return;
        if (firstIndex < targetIndex) {
            for (let index = firstIndex + 1; index < targetIndex; index++) {
                const task = filtredTask[index];
                if (!task?.selected) {
                    api.exec("select-task", {
                        id: task.id,
                        join: true,
                    });
                    setChildrenSelection(api, task.id);
                }
            }
        }
        else if (firstIndex > targetIndex) {
            for (let index = firstIndex - 1; index > targetIndex; index--) {
                const task = filtredTask[index];
                if (!task?.selected) {
                    api.exec("select-task", {
                        id: task.id,
                        join: true,
                    });
                    setChildrenSelection(api, task.id);
                }
            }
        }
    }
}
function setChildrenSelection(api, id) {
    const children = api.getChildrenIds({ id });
    for (const childId of children) {
        const child = api.getTask({ id: childId });
        !child?.selected &&
            api.exec("select-task", {
                id: childId,
                join: true,
            });
    }
}
//# sourceMappingURL=selection.js.map